(function (angular) {
    'use strict';

    angular.module('messenger')
        /**
         *
         */
        .controller('messengerController',
            ['$scope', '$rootScope', '$location', 'facebookService', '$window', '$stateParams', "growlService", "facebookSDKService", "apiSpacePicker", "portalConfig", "config", "$uibModalInstance", 'WizardHandler', 'fbData',
                function ($scope, $rootScope, $location, facebookService, $window, $stateParams, growlService, facebookSDKService, apiSpacePicker, portalConfig, config, $uibModalInstance, WizardHandler, fbData) {

                    var signedIn = false;

                    $scope.finished = function () {
                        if (Object.keys($location.search()).length > 0) {
                            $location.search({});
                        }
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.canExitStepOne = function () {
                        return true;
                    };

                    $scope.canExitStepTwo = function () {
                        return WizardHandler.wizard("fbWizard").currentStepNumber() === 2 && signedIn || WizardHandler.wizard("fbWizard").currentStepNumber() === 3;
                    };

                    $scope.canExitStepTree = function () {
                        return $scope.facebookData.pickedPageIndex && WizardHandler.wizard("fbWizard").currentStepNumber() >= 3;
                    };

                    $scope.facebookData = {};
                    $scope.facebookPage = fbData || {};

                    $scope.start = function () {

                        facebookService.getAppId($stateParams.pickedApiSpaceId).then(function (response) {
                            $scope.facebookData.appId = response;
                        });
                    };

                    $scope.check = function () {

                        if (config && config != 'fbMessenger' && Object.keys(config).length > 0) {

                            $scope.facebookData.appId = config.appId;
                            $scope.facebookData.shortLiveToken = config.shortLiveToken;
                            $scope.accessError = config.accessError;

                            if ($scope.accessError) {
                                // WizardHandler.wizard("fbWizard").next();
                                WizardHandler.wizard("fbWizard").goTo("Login");
                            } else {
                                $scope.goPagePicker();
                            }

                        }
                        else {
                            $scope.start();
                        }
                    };

                    $scope.deleteFacebookChannel = function () {
                        facebookService.deleteFacebookConfig($stateParams.pickedApiSpaceId).then(function () {
                            $scope.facebookPage = {};
                            $scope.facebookData = {
                                appId: $scope.facebookData.appId
                            };
                            growlService.success('Facebook successfully deleted');
                        }).catch(function (error) {
                            growlService.danger("Facebook wasn't successfully deleted due to: " + error.statusText);
                        });
                    };

                    $scope.goToFacebookLogin = function () {
                        if (!facebookSDKService.isLoaded()) {
                            facebookSDKService.init({
                                appId: $scope.facebookData.appId,
                                status: true,
                                cookie: true,
                                xfbml: true
                            });
                        }

                        facebookSDKService.subscribe('auth.authResponseChange', function (res) {
                            if (res.status === 'connected') {
                                signedIn = true;
                                growlService.success('Facebook login succeeded');
                                $scope.shortLiveToken = res.authResponse.accessToken;
                                $scope.$apply();
                                $scope.goAppShortToken();
                            }
                        });

                        WizardHandler.wizard("fbWizard").next();
                    };

                    $scope.goAppShortToken = function () {

                        var state = encodeURIComponent('{apiSpaceId=' + $stateParams.pickedApiSpaceId + ',appId=' + $scope.facebookData.appId + '}');

                        $window.location.href = 'https://www.facebook.com/dialog/oauth?' +
                            'client_id=' + $scope.facebookData.appId +
                            '&scope=' + portalConfig.fbPermissionsScope +
                            '&redirect_uri=' + $window.location.protocol + '//' + $window.location.host + '/redirector.html' +
                            '&state=' + state +
                            '&response_type=token';
                    };

                    $scope.selectPage = function (index) {
                        $scope.facebookData.pickedPageIndex = index;
                    };

                    $scope.goPagePicker = function () {
                        facebookService.getLongAccessToken($stateParams.pickedApiSpaceId, $scope.facebookData.shortLiveToken)
                            .then(function (response) {
                                $scope.facebookData.longToken = response;
                                facebookService.getPages($scope.facebookData.longToken).then(function (response) {
                                    $scope.facebookData.pages = response.data;
                                    WizardHandler.wizard("fbWizard").goTo('Settings');
                                }).catch(function (error) {
                                    growlService.danger("List of pages wasn't generated due to: " + error.statusText);
                                });
                            }).catch(function (error) {
                                console.error("Long live token wasn't generated due to: " + error.statusText);
                            });
                    };

                    $scope.getPage = function (index) {
                        return $scope.facebookData.pages[index];
                    };

                    $scope.saveData = function () {
                        $scope.pickedPage = $scope.getPage($scope.facebookData.pickedPageIndex);
                        facebookService.savePageToComapi($stateParams.pickedApiSpaceId, $scope.pickedPage.id, $scope.pickedPage.name, $scope.pickedPage.access_token, $scope.facebookData.allowPhoneNumber).then(function (response) {
                            growlService.success('Page access token successfully saved');
                            $rootScope.$broadcast('FB channel configured');
                            if (Object.keys($location.search()).length > 0) {
                                $location.search({});
                            }
                            $uibModalInstance.close('saved');

                        }).catch(function (error) {
                            if (error.status == 400 && error.data.validationFailures) {
                                if (!$scope.validationErrors) {
                                    $scope.validationErrors = {};
                                }
                                var apiSpaces = apiSpacePicker.getApiSpaces();
                                var apiSpacesName;
                                for (var i in apiSpaces) {
                                    if (apiSpaces[i].id == error.data.validationFailures.paramValue) {
                                        apiSpacesName = apiSpaces[i].name;
                                    }
                                }
                                $scope.validationErrors[$scope.pickedPage.id] = {
                                    apiSpaceId: error.data.validationFailures.paramValue,
                                    apiSpaceName: apiSpacesName
                                };
                                growlService.danger("Page wasn't set because this page is already in use by other Api Space");
                            }
                            else {
                                growlService.danger("Page access token wasn't set due to: " + error.statusText);
                            }
                        });
                    };

                    $scope.stopEditing = function () {
                        $scope.editing = false;
                        $scope.facebookData = {
                            appId: $scope.facebookData.appId
                        };
                    };
                    $scope.check();
                }
            ]);


})(window.angular);
